import { render } from "./ArticleCardsWithMoreButton.vue?vue&type=template&id=699bafa6&ts=true"
import script from "./ArticleCardsWithMoreButton.vue?vue&type=script&lang=ts"
export * from "./ArticleCardsWithMoreButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__